module.exports = __webpack_public_path__ + "static/media/change.bb2ef0c5.svg";